import { Component, EventEmitter, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { ThemeService } from '../shared/services/theme.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MenuComponent {
    public themeService = inject(ThemeService);
    @Output() themeChange: EventEmitter<string> = new EventEmitter<string>();

    toggleTheme() {
        const next = this.themeService.currentThemeValue === 'midnight-obsidian' ? 'slate-indigo' : 'midnight-obsidian';
        this.themeChange.emit(next);
    }
}
